import { render, staticRenderFns } from "./PeriodicChecks.vue?vue&type=template&id=2d2882c8&scoped=true"
import script from "./PeriodicChecks.vue?vue&type=script&lang=js"
export * from "./PeriodicChecks.vue?vue&type=script&lang=js"
import style0 from "./PeriodicChecks.vue?vue&type=style&index=0&id=2d2882c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2882c8",
  null
  
)

export default component.exports